import { VehicleHistoryEvent } from './vehicle-history-event';
import moment from 'moment';

export class OffRouteEvent extends VehicleHistoryEvent {
    public type = 'OffRouteEvent';

    latitude: number;
    longitude: number;
    eventType: 'OffRoute' | 'BackOnRoute';

    // Comes from the StopMetaData
    trafficDate: Date;
    geoFenceName: string;
    vehicleTaskNumber: string;
    sequenceNumber: number;
    isLastOnActivity: boolean;
    activityType: string;
    tripNumber: string;
    activityStartTime: string;
    routeName: string;
    routePublicName: string;
    placeId: string;
    nextPlaceId: string;
    isMeasurementStop: boolean;
    isTimingPoint: boolean;
    isLastInVehicleActivity: boolean;

    constructor(obj = null) {
        super();

        if (obj) {
            Object.assign(this, obj);
        }

        if (obj?.metadata) {
            Object.assign(this, obj?.metadata);
        }

        if (obj?.position) {
            Object.assign(this, obj?.position);
        }

        if (obj?.trafficDate) {
            this.trafficDate = moment(obj.ts).toDate();
        }
    }
}
